// Emblems for the Hall's cards. Matt: "it would be great if these actually
// looked like cards... let's try to make this thing look more like I'm
// playing a deck builder, less like I'm pushing buttons on a computer."
//
// Line art, not pictures: constant SVG in a 48x48 box, drawn in
// currentColor so a card's kind colours its own emblem. No files to load,
// nothing to go missing offline, and it costs about a kilobyte.
//
// Keyed by card id, falling back to the kind, so a new card gets a sensible
// emblem for free and a better one whenever somebody draws it.

const ART = {
  // ---- customs
  rally: '<circle cx="12" cy="30" r="5"/><circle cx="24" cy="27" r="5"/><circle cx="36" cy="30" r="5"/><path d="M5 42h38"/><path d="M24 20V9m0 0-4 4m4-4 4 4"/>',
  gathering: '<circle cx="24" cy="26" r="13"/><circle cx="24" cy="26" r="4"/><path d="M24 4v6M24 42v2M6 26h6M36 26h6M11 13l4 4M37 13l-4 4"/>',
  feast: '<path d="M8 22h32a16 16 0 0 1-32 0Z"/><path d="M12 42h24"/><path d="M24 38v-3"/><path d="M18 14c0-3 3-3 3-6M27 14c0-3 3-3 3-6"/>',
  feast_day: '<path d="M8 22h32a16 16 0 0 1-32 0Z"/><path d="M12 42h24"/><path d="M24 38v-3"/><path d="M18 14c0-3 3-3 3-6M27 14c0-3 3-3 3-6"/>',
  levy: '<path d="M12 44V6"/><path d="M12 8h24l-5 7 5 7H12Z"/><circle cx="12" cy="4" r="2"/>',
  proclamation: '<path d="M12 44V6"/><path d="M12 8h24l-5 7 5 7H12Z"/><circle cx="12" cy="4" r="2"/>',
  edict_of_hands: '<path d="M12 44V6"/><path d="M12 8h24l-5 7 5 7H12Z"/><circle cx="12" cy="4" r="2"/>',
  edict_of_grain: '<path d="M12 44V6"/><path d="M12 8h24l-5 7 5 7H12Z"/><circle cx="12" cy="4" r="2"/>',
  grow: '<path d="M8 42V24l16-12 16 12v18Z"/><path d="M20 42V31h8v11"/><path d="M24 12V4m0 4c-4 0-6-2-6-5 3 0 6 1 6 5Zm0 0c4 0 6-2 6-5-3 0-6 1-6 5Z"/>',
  elders_speak: '<path d="M6 10h36v22H26l-9 9v-9H6Z"/><circle cx="17" cy="21" r="2"/><circle cx="24" cy="21" r="2"/><circle cx="31" cy="21" r="2"/>',
  old_custom: '<path d="M24 24a6 6 0 1 1-6 6 12 12 0 1 1 12-12 18 18 0 1 1-18 18"/>',
  harvest_rite: '<path d="M24 44V18"/><path d="M24 18c-5-3-8-8-7-14 6 1 9 6 7 14Zm0 0c5-3 8-8 7-14-6 1-9 6-7 14Z"/><path d="M24 30c-5-2-9-5-10-10 6 0 10 3 10 10Zm0 0c5-2 9-5 10-10-6 0-10 3-10 10Z"/>',
  census: '<path d="M10 12v24M18 12v24M26 12v24M34 12v24"/><path d="M6 34 40 14"/>',
  tithe: '<ellipse cx="24" cy="14" rx="14" ry="5"/><path d="M10 14v8c0 3 6 5 14 5s14-2 14-5v-8"/><path d="M10 26v8c0 3 6 5 14 5s14-2 14-5v-8"/>',

  // ---- the laws
  law_of_weights: '<path d="M24 8v30"/><path d="M8 16h32"/><path d="M8 16 3 28h10ZM40 16l-5 12h10Z"/><path d="M14 42h20"/>',
  law_of_the_well: '<path d="M10 20h28v22H10Z"/><path d="M10 20 24 8l14 12"/><path d="M18 30h12v12H18Z"/>',
  law_of_the_watch: '<path d="M10 42V18l14-10 14 10v24Z"/><path d="M10 18h28"/><path d="M20 42V28h8v14"/>',

  // ---- the songs
  song: '<path d="M18 38V10l18-4v28"/><circle cx="13" cy="38" r="5"/><circle cx="31" cy="34" r="5"/>',
  play: '<path d="M6 10h16v14a8 8 0 0 1-16 0Z"/><path d="M26 10h16v14a8 8 0 0 1-16 0Z"/><circle cx="11" cy="17" r="1.6"/><circle cx="17" cy="17" r="1.6"/><circle cx="31" cy="17" r="1.6"/><circle cx="37" cy="17" r="1.6"/>',

  // ---- what the world puts in the deck
  grievance: '<path d="M16 16h16l3 26H13Z"/><path d="M18 8h12l2 8H16Z"/><path d="m24 20-4 8 6 2-4 8"/>',
  mourning: '<path d="M18 22h12v20H18Z"/><path d="M24 22V12"/><path d="M24 12c-3-3-3-6 0-9 3 3 3 6 0 9Z"/>',
  grudge: '<path d="M12 6h24v36H12Z"/><path d="M12 6v36"/><circle cx="30" cy="24" r="2"/><path d="M20 6v36"/>',

  // ---- the year's fixed months (DESIGN.md "The Year")
  year_card: '<circle cx="24" cy="24" r="16"/><path d="M24 8v4M24 36v4M8 24h4M36 24h4"/><path d="M24 24l6-8"/>',
  the_harvest: '<path d="M10 40h28"/><path d="M14 40V22l10-8 10 8v18"/><path d="M24 14V6M18 10l6-4 6 4"/><path d="M20 40v-8h8v8"/>',
  midwinter: '<path d="M24 6v36M8 24h32M12 12l24 24M36 12L12 36"/><circle cx="24" cy="24" r="5"/>',
  year: '<circle cx="24" cy="24" r="16"/><path d="M24 24l6-8"/>',
  harvest: '<path d="M10 40h28"/><path d="M14 40V22l10-8 10 8v18"/>',
  // ---- fallbacks, one per kind
  custom: '<circle cx="24" cy="24" r="16"/><path d="M24 14v20M14 24h20"/>',
  law: '<path d="M14 6h20l4 6v30H14Z"/><path d="M19 18h14M19 25h14M19 32h9"/>',
  edict: '<path d="M12 44V6"/><path d="M12 8h24l-5 7 5 7H12Z"/>',
};

export const artFor = (id, kind) => ART[id] || ART[kind] || ART.custom;
